<template>
  <div>
   <div class="grid-row">
      <div class="titulo-grid">
        Viabilidade Pré Venda - Dados da SEV
      </div> 
  </div>
  <div v-if="pcoCircuitoSSA.code != 0">
    <div class="grid-row">
      <div class="titulo-center destaque-texto">
        SEV Inválida
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
        Número da SEV
      </div>
      <div class="">
        {{ numeroSev }}
      </div>
      <div class="titulo">
        Mensagem
      </div>
      <div class="">
        {{ pcoCircuitoSSA.message }}
      </div>
    </div>
  </div>
  <div v-else>
    <div class="grid-row">
      <div class="titulo">
        Número da SEV
      </div>
      <div class="">
        {{ numeroSev }}
      </div>
      <div class="titulo">
        UF
      </div>
      <div class="">
        {{ pcoCircuitoSSA.acronym_state_or_province }}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
        Serviço
      </div>
      <div class="">
        {{ pcoCircuitoSSA.product_specification_type }}
      </div>
      <div class="titulo">
        Município
      </div>
      <div class="">
        {{ pcoCircuitoSSA.locality}}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
        Sigla Serviço
      </div>
      <div class="">
        {{ pcoCircuitoSSA.product_acronym }}
      </div>
      <div class="titulo">
        Bairro
      </div>
      <div class="">
        {{ pcoCircuitoSSA.neighborhood }}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
        Status SEV
      </div>
      <div class="">
        {{ pcoCircuitoSSA.interaction_status }}
      </div>
      <div class="titulo">
        Número
      </div>
      <div class="">
        {{ pcoCircuitoSSA.street_nr }}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
        Validade
      </div>
      <div class="">
        {{ pcoCircuitoSSA.service_solution_delivery_estimated_time }}
      </div>
      <div class="titulo">
        Tipo Logradouro
      </div>
      <div class="">
        {{ pcoCircuitoSSA.street_type }}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
        Data de Vencimento
      </div>
      <div class="">
        {{ formataDataBr(pcoCircuitoSSA.service_solution_expiry_date, true) }}
      </div>
      <div class="titulo">
        Logradouro
      </div>
      <div class="">
        {{ pcoCircuitoSSA.street_name }}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
       Provedor
      </div>
      <div class="">
        {{ pcoCircuitoSSA.specification_type }}
      </div>
      <div class="titulo">
        Facilidade
      </div>
      <div class="">
        {{ pcoCircuitoSSA.specification_category }}
      </div>
    </div>
    <div class="grid-row">
      <div class="titulo">
       Mensagem
      </div>
      <div class="">
        {{ pcoCircuitoSSA.message }}
      </div>
      <div class="titulo">
        Observações
      </div>
      <div class="">
        {{ pcoCircuitoSSA.service_solution_description }}
      </div>
    </div>
  </div>
<!-- 
  

  <div class="grid-row">
    <div class="titulo">
      Designação
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.designacao.toUpperCase() }}
    </div>
    <div class="titulo">
      Velocidade
    </div>
    <div class="">
      {{ dadosFichaTecnica.pco_tarefa.pco_circuito.velocidade.toUpperCase() }}
    </div>
  </div> -->
 </div>  
</template>

<script>

import { formataDataBr } from '@/common/boot/Utils'

export default {
  name: "InformacoesDadosSevComponent",
  props: {
    pcoCircuitoSSA: {
      type: Array,
      required: true
    },
    numeroSev: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {

    formataDataBr
  }
}
</script>